export interface FeaturedProduct {
  id: string;
  name: string;
  description: string;
  image: string;
  imageWidth: number;
  imageHeight: number;
  category: string;
  url: string;
}

export const featuredProducts: FeaturedProduct[] = [
  {
    id: 'fp-1',
    name: 'Sneakers \u00c9dition Limit\u00e9e',
    description: 'Design \u00e9pur\u00e9, cuir premium italien, semelle extra-l\u00e9g\u00e8re. Parfait pour un look urbain sophistiqu\u00e9.',
    image: 'https://readdy.ai/api/search-image?query=Elegant%20minimalist%20sage%20green%20and%20cream%20colorway%20running%20shoes%20on%20clean%20studio%20background%20soft%20natural%20light%20Scandinavian%20aesthetic%20product%20photography%20high%20detail%20warm%20neutral%20tones%20simple%20composition&width=800&height=800&seq=fp-sneakers-v3&orientation=squarish',
    imageWidth: 800,
    imageHeight: 800,
    category: 'Chaussures',
    url: 'https://kaspreadsheet.com/category-911-Shoes.html',
  },
  {
    id: 'fp-2',
    name: 'Pull Cachemire Premium',
    description: 'Cachemire italien 100%, coupe droite \u00e9l\u00e9gante, finitions main. Un confort absolu pour toutes les saisons.',
    image: 'https://readdy.ai/api/search-image?query=Elegant%20minimalist%20premium%20cashmere%20sweater%20in%20soft%20oatmeal%20beige%20folded%20neatly%20on%20clean%20cream%20surface%20editorial%20product%20photography%20minimalist%20Scandinavian%20style%20gentle%20shadows%20warm%20tones&width=800&height=800&seq=fp-sweater-v3&orientation=squarish',
    imageWidth: 800,
    imageHeight: 800,
    category: 'Hoodies & Sweats',
    url: 'https://kaspreadsheet.com/category-912-Hoodies%2FSweaters.html',
  },
  {
    id: 'fp-3',
    name: 'Sac Bandouli\u00e8re Structur\u00e9',
    description: 'Cuir pleine fleur terracotta, design intemporel, compartiments intelligents. L\u2019accessoire indispensable du quotidien.',
    image: 'https://readdy.ai/api/search-image?query=Elegant%20minimalist%20structured%20leather%20crossbody%20bag%20in%20warm%20terracotta%20color%20on%20clean%20cream%20studio%20background%20soft%20natural%20lighting%20minimalist%20luxury%20product%20photography%20high%20detail%20simple%20composition&width=800&height=800&seq=fp-crossbody-v3&orientation=squarish',
    imageWidth: 800,
    imageHeight: 800,
    category: 'Sacs',
    url: 'https://kaspreadsheet.com/category-921-Bags.html',
  },
];